import type { Branch, Sale, SaleItem } from '@/lib/types';
import { PrintService } from './PrintService';
import { buildInvoiceHTML } from './invoiceTemplate';
import type { PaperWidth, PrintResult } from './printTypes';

export interface PrintSaleOptions {
  branch: Branch | null;
  sale: Sale;
  items: SaleItem[];
  currencySymbol?: string;
  paperWidth?: PaperWidth;
  copies?: number;
  printerName?: string | null;
  showLogo?: boolean;
  showCashier?: boolean;
  showPayment?: boolean;
  showAddress?: boolean;
  showPhone?: boolean;
  showRnc?: boolean;
  showDatetime?: boolean;
  footerMessage?: string;
}

/**
 * Imprime una venta a través de la capa única de impresión.
 * El POS y el detalle de venta usan este helper para no acoplarse al entorno.
 */
export async function printSaleInvoice(options: PrintSaleOptions): Promise<PrintResult> {
  const {
    branch,
    sale,
    items,
    currencySymbol = 'RD$',
    paperWidth = '80mm',
    copies = 1,
    printerName,
    showLogo = true,
    showCashier = true,
    showPayment = true,
    showAddress = true,
    showPhone = true,
    showRnc = true,
    showDatetime = true,
    footerMessage,
  } = options;

  const html = buildInvoiceHTML(
    {
      branch,
      sale,
      items,
      currencySymbol,
      showCashier,
      showPayment,
      showLogo,
      showAddress,
      showPhone,
      showRnc,
      showDatetime,
      footerMessage,
    },
    paperWidth,
  );

  return PrintService.printHTML(html, {
    paperWidth,
    copies,
    printerName: printerName ?? undefined,
  });
}